import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { SettlementsService } from "../shared/settlements.service";
import { ToastrService } from "ngx-toastr";
import { SelectItem } from "primeng/api";
import { TripCharge } from "@app/shared/models/trips/TripCharge.model";
import { RateCalculatorService } from "@app/trip-new/shared/rate-calculator.service";
import { Table } from "primeng/table";
import { TripSignalrService } from "@app/trip-new/shared/trip-signalr.service";

@Component({
  selector: "app-allloads",
  templateUrl: "./all-loads.component.html",
  styleUrls: ["./all-loads.component.css"],
})
export class AllLoadsComponent implements OnInit {
  @ViewChild("dt", { static: true }) dataTable: Table;

  cols: any[];
  colsCharge: { field: string; header: string; width: number }[];
  driverChargeTypes: SelectItem[] = [];

  batchId: string;
  trips: any = [];
  batchInfo: any;
  totalEarnings = 0;

  allTripsList: any = [];
  filters: any = {
    tripNo: "",
    driverName: "",
    startDate: "",
    endDate: "",
    netNonTripExpense: "",
  }

  constructor(
    private settlementsService: SettlementsService,
    private activatedRoute: ActivatedRoute,
    private rateCalculaterService: RateCalculatorService,
    private signalRService: TripSignalrService,
    private toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit() {
    this.setupSignalRListeners();

    this.cols = [
      { field: "tripNo", header: "Trip No", width: 100, type: "trip" },
      { field: "driverName", header: "Driver", width: 230 },
      { field: "startDate", header: "Start Date", type: "date" },
      { field: "endDate", header: "End Date", type: "date" },
      { field: "netNonTripExpense", header: "Total", type: "currency", width: 100 },
    ];

    this.colsCharge = [
      { field: "chargeType?.description", header: "Type", width: 250 },
      { field: "description", header: "Description", width: 250 },
      { field: "units", header: "Units", width: 50 },
      { field: "miles", header: "Miles", width: 50 },
      { field: "chargeRate", header: "Rate", width: 100 },
      { field: "price", header: "Total", width: 100 },
    ];

    this.activatedRoute.params.subscribe((params: Params) => {
      this.batchId = params["batchId"];
      this.getAllLoads();
      this.loadBatchInfo();
    });

    const chargeTypes = this.activatedRoute.snapshot.data.chargeTypes;
    this.driverChargeTypes = chargeTypes.filter(
      (item: SelectItem) => item.value.expenseGL && !item.value.isAccessorial
    );
  }

  edit(trip: any) {
    console.log("trip", trip);
    if(trip.status == "FINISHED" || trip.status == "IN PROGRESS" || trip.status == "DOCS FINISHED"){
      this.router.navigate(["/new/edittrip/", trip.id, "/Q"]);
    }
    if(trip.status == "ON REVIEW"){
      this.router.navigate(["/new/edittrip/", trip.id, "/BR"]);
    }
    if(trip.status == "INVOICE"){
      this.router.navigate(["/new/edittrip/", trip.id, "/RB"]);
    }
    if(trip.status == "BILLED"){
      this.router.navigate(["/new/billInfo/", trip.id]);
    }
  }

  loadBatchInfo() {
    this.settlementsService.getBatch(this.batchId).subscribe((batchInfoResult: any) => {
      this.batchInfo = batchInfoResult;
    });
  }

  addFilter(value: any, field: string) {
    this.filters[field] = value;
    this.getAllLoads();
  }

  getAllLoads() {
    this.settlementsService.getAllLoadsForBatch(this.batchId).subscribe((res: any) => {
      this.trips = res;
      this.trips = res.filter((trip) => {
        return Object.keys(this.filters).every((field) => {
          const filterValue = this.filters[field];
          if (!filterValue) return true;
          const tripValue = trip[field]?.toString().toLowerCase() || "";
          return tripValue.includes(filterValue.toLowerCase());
        });
      });
      this.calculateTotal();
      this.dataTable.filters = {};
      this.updateActiveTrips();
    });
  }

  calculateTotal() {
    // total earnings is the sum of all driver charges on all trips
    const sumDriverCharges = (trip) => {
      return trip.driverCharges.reduce((acc, charge) => {
        return acc + (charge.delete ? 0 : charge.price);
      }, 0);
    };

    for (const trip of this.trips) {
      trip.netNonTripExpense = sumDriverCharges(trip);
    }

    this.totalEarnings = this.trips
      .filter((trip) => trip.include)
      .reduce((acc, trip) => {
        return acc + trip.netNonTripExpense;
      }, 0);
  }

  selectAllEarnings() {
    for (const trip of this.trips) {
      trip.include = true;
    }
    this.calculateTotal();
  }

  editCharge(charge: TripCharge) {
    charge.price = this.rateCalculaterService.calculateChargePrice(charge);
    charge.changed = true;

    this.calculateTotal();
  }

  addCharge(tripPayment) {
    tripPayment.driverCharges.push({
      TripId: tripPayment.TripId,
      PaymentTripId: tripPayment.id,
      changed: true,
    });
  }

  removeCharge(driverCharges: TripCharge[], charge: TripCharge) {
    if (charge.id == null) driverCharges.splice(driverCharges.indexOf(charge), 1);
    else charge.delete = true;

    this.calculateTotal();
  }

  saveChanges() {
    this.settlementsService.updateAllLoads(this.batchId, this.trips).subscribe(
      (res) => {
        this.toastr.success("Earnings updated successfully");
        this.getAllLoads();
      },
      (err) => {
        this.toastr.error("Server Error when saving changes");
      }
    );
  }

  setupSignalRListeners() {
    this.signalRService.subscribeToAllTrips().then(() => {
      this.signalRService.allActiveTrips.subscribe((allTrips) => {
        this.allTripsList = allTrips;
        this.updateActiveTrips();
      });
    });
  }

  updateActiveTrips() {
    this.trips.forEach((trip) => {
      if (this.allTripsList[trip.id]) {
        trip.activeUsers = this.allTripsList[trip.id];
        trip.activeUsersTooltip = `Active users: ${this.allTripsList[trip.id].join(", ")}`;
      } else {
        trip.activeUsers = [];
        trip.activeUsersTooltip = "No active users";
      }
    });
  }
}
